module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Ramlinsburg-a46603de171f035aff154405f77f1d0d.svg";